import React, { lazy } from "react";
import { ShowAnchorsContext, scrollWithOffset } from "Constants";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {Helmet} from 'react-helmet';
import ApplicationReveal from "../common/animations/ApplicationReveal";
import BannersCarousel from "./home/sections/BannersCarouselV1";
import AppSuspense from "components/common/util/AppSuspense";
const AboutUs = lazy(async () => import("./home/sections/AboutUs"));
const CentersListSlider = lazy(
  async () => import("./home/sections/CentersListSlider")
);
const Contact = lazy(async () => import("./home/sections/Contact"));
const Discounts = lazy(async () => import("./home/sections/Discounts"));
const FAQs = lazy(async () => import("./home/sections/FAQs"));
const Gallery = lazy(async () => import("./home/sections/Gallery"));
const KeyFeatures = lazy(async () => import("./home/sections/KeyFeatures"));
const KeyStatistics = lazy(async () => import("./home/sections/KeyStatistics"));
// const AboutUs = lazy(async () => import("./home/sections/AboutUs"));
// const BannersCarousel = lazy(
//   async () => import("./home/sections/BannersCarousel")
// );
// const CentersListSlider = lazy(
//   async () => import("./home/sections/CentersListSlider")
// );
// const Contact = lazy(async () => import("./home/sections/Contact"));
// const Discounts = lazy(async () => import("./home/sections/Discounts"));
// const FAQs = lazy(async () => import("./home/sections/FAQs"));
// const Gallery = lazy(async () => import("./home/sections/Gallery"));
// const KeyFeatures = lazy(async () => import("./home/sections/KeyFeatures"));
// const KeyStatistics = lazy(async () => import("./home/sections/KeyStatistics"));

const Home = () => {
  const [showAnchors, setShowAnchors] = useState(true);

  const { hash } = useLocation();

  const getSectionOffsets = () => {
    const homePageElement = Array.from(
      document.getElementById("home-page")?.childNodes || []
    ) as HTMLElement[];

    return [...homePageElement].map(
      (child) =>
        (child.getElementsByClassName("section-title")[0] as HTMLElement)
          ?.innerText
    );
  };

  const getSectionsData = () => {
    const homePageElement = Array.from(
      document.getElementById("home-page")?.childNodes || []
    ) as HTMLElement[];

    return [...homePageElement].slice(1).map((child) => {
      const section = child.getElementsByClassName(
        "section-title"
      )[0] as HTMLElement;
      return {
        innerText: section?.innerText,
        offsetTop: section?.offsetTop,
        height: section?.offsetHeight,
      };
    });
  };

  const logSectionOffsets = () => {
    const homePageElement = Array.from(
      document.getElementById("home-page")?.childNodes || []
    ) as HTMLElement[];

    console.table(
      [...homePageElement].map((child) => {
        const other = document.createElement("div", {});
        other.innerText = (child.firstChild as HTMLElement)?.id || "ID";
        return {
          name: (
            (child.getElementsByClassName("section-title")[0] as HTMLElement) ||
            other
          ).innerText,
          top: child.offsetTop,
        };
      })
    );
  };

  useEffect(() => {
    (async () => {
      // console.log("Hash", hash);
      console.table(getSectionsData());
      if (hash) {
        // while (true) {
        //   const out = getSectionsData().reduce(
        //     (out, curr) => out && curr.height > 20,
        //     true
        //   );
        //   if (out) {
        //     setShowAnchors(true);
        //     break;
        //   }

        // }
        const element = document.getElementById(hash.slice(1));
        // console.log(element);
        if (element) {
          scrollWithOffset(element);
        }
        // if (element) {
        //   element.scrollIntoView({ behavior: "smooth" });
        // }
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    })();
  }, [hash]);

  const slides = [
    // <BannersCarousel />,
    <AboutUs />,
    <KeyStatistics />,
    <KeyFeatures />,
    <CentersListSlider />,
    <Discounts />,
    <Gallery />,
    <FAQs />,
    <Contact />,
  ];

  return (
    <>
    <Helmet>
      <title>STPI Workspace | Home</title>
      <meta name="description" content="Discover STPI Workspace, offering premium incubation services for SMEs. With ready-to-operate facilities, zero gestation period, and no capital investment needed, STPI ensures your software business starts seamlessly from day one. Build confidence and seize business opportunities with STPI's state-of-the-art incubation centers." />

    </Helmet>
    <ShowAnchorsContext.Provider value={showAnchors}>
      <div id="home-page">
        <BannersCarousel />
        {slides.map((slide, index) => (
          <ApplicationReveal
            key={index}
            type={"fade"}
            direction="up"
            big
            fraction={0}
            delay={200}
            duration={800}
            cascade={undefined}
          >
            <AppSuspense>{slide}</AppSuspense>
          </ApplicationReveal>
        ))}
      </div>
    </ShowAnchorsContext.Provider>
    </>
  );
};

/*
const slider = useRef<Slider>(null);
  const sliderParentRef = useRef<HTMLDivElement>(null);

  const settings: Settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
  };

  const slide = (y: number) => {
    y > 0 ? (
       slider.current?.slickNext()
    ) : (
       slider.current?.slickPrev()
    )
  }

  useEffect(() => {
    logger.log(sliderParentRef);
    const sliderParent = sliderParentRef.current
    sliderParent?.addEventListener('wheel', (e) => {
      logger.log(e);
      e.preventDefault();
      e.stopImmediatePropagation();
      slide(e.deltaY);
    }, {passive: false})
    return () => {
      sliderParent?.removeEventListener('wheel', () => {
        logger.log("Remove Wheel Listener from window.");
      })
    }
  }, [sliderParentRef])

  <div ref={sliderParentRef}>
<Slider ref={slider} {...settings}>
      {slides.map((slide, index) => (
        <div key={index}>
          <div style={{paddingTop: "75px", height: "calc(100vh - 75px)", overflow: "auto"}} className="d-flex justify-content-center align-items-center">
            {slide}
          </div>
        </div>
      ))}
    </Slider>
</div>
<ApplicationReveal
  type={"fade"}
  direction="up"
  big
  fraction={0}
  delay={0}
  duration={800}
  cascade={undefined}
>
</ApplicationReveal>
*/

export default Home;
